import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n';
import ResetPasswordInput from './component/ResetPasswordInput';
import { resetPassword, loadCurrentPassword } from './ResetPasswordActions';
import { validatePassword } from './util';

class ResetPassword extends React.Component {
  constructor() {
    super();
    this.state = {
      password: '',
      validPassword: true,
      loading: false,
      userFeedback: null,
    };
  }

  componentDidMount() {
    this.props.loadCurrentPassword();
  }

  onChange = (value) => {
    this.setState({ password: value, userFeedback: null });

    if (!value) {
      this.setState({ validPassword: false });
      return;
    }

    const validation = validatePassword(value);

    if (validation.error) {
      this.setState({ validPassword: false });
      return;
    }

    this.setState({ validPassword: value !== this.props.currentPassword });
  };

  submit = () => {
    this.setState({ loading: true }, () => {
      this.props
        .resetPassword(this.props.userName, this.state.password)
        .then((success) => {
          this.setState({ loading: false, userFeedback: success });
        });
    });
  };

  renderUserFeedback = () => {
    if (this.state.loading) {
      return <CircularProgress />;
    }

    const { userFeedback } = this.state;
    if (userFeedback === true) {
      return (
        <div className="feedback-addin feedback-addin-success">
          <Icon>check_circle_outline</Icon>
          <Translate value="resetPassword.form.feedback.success" />
        </div>
      );
    }

    if (userFeedback === false) {
      return (
        <div className="feedback-addin feedback-addin-failure">
          <Icon>warning</Icon>
          <Translate value="resetPassword.form.feedback.failure" />
        </div>
      );
    }

    return true;
  };

  render() {
    const disableSubmit =
      !this.state.validPassword ||
      !this.state.password ||
      this.state.loading ||
      this.state.userFeedback !== null;
    return (
      <div>
        <div className="bodycontent">
          <Typography variant="h2" className="title__center" gutterBottom>
            <Translate value="resetPassword.form.title" />
          </Typography>
          <Typography className="title__center" gutterBottom>
            <Translate value="resetPassword.form.helpText" />
          </Typography>

          <div className="settings__password">
            <TextField
              type="text"
              label={I18n.t('resetPassword.form.userNameInput')}
              name="username"
              value={this.props.userName}
              className="settings__username-field"
              InputProps={{
                readOnly: true,
              }}
            />
          </div>
          <div className="settings__password">
            <ResetPasswordInput
              disabled={this.state.loading || this.props.loading}
              onChange={this.onChange}
              error={!this.state.validPassword}
              value={this.state.password || this.props.currentPassword}
            />
          </div>
          <div className="settings__button-cont">
            <Button
              variant="contained"
              color="primary"
              className="btn btn-primary"
              disabled={disableSubmit}
              onClick={this.submit}
            >
              <Translate value="resetPassword.form.submitButton" />
            </Button>
            {this.renderUserFeedback()}
          </div>
        </div>
      </div>
    );
  }
}

ResetPassword.propTypes = {
  userName: PropTypes.string,
  currentPassword: PropTypes.string,
  resetPassword: PropTypes.func.isRequired,

  loadCurrentPassword: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

const mapDispatcherToPros = {
  resetPassword,
  loadCurrentPassword,
};

const mapStateToProps = (state) => {
  const { resetPassword: resetPasswordState } = state;
  return { ...resetPasswordState };
};

export default connect(mapStateToProps, mapDispatcherToPros)(ResetPassword);
